/**
 * @generated SignedSource<<6d9c5f86bcaaf7fc61e74740f79349b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ProfileQueriesProfileVesselsListQuery$variables = {
  id?: string | null;
};
export type ProfileQueriesProfileVesselsListQuery$data = {
  readonly vesselList: {
    readonly totalCount: number;
  } | null;
};
export type ProfileQueriesProfileVesselsListQuery = {
  response: ProfileQueriesProfileVesselsListQuery$data;
  variables: ProfileQueriesProfileVesselsListQuery$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'ownerId',
            variableName: 'id',
          },
        ],
        concreteType: 'VesselConnection',
        kind: 'LinkedField',
        name: 'vesselList',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'totalCount',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'ProfileQueriesProfileVesselsListQuery',
      selections: v1 /*: any*/,
      type: 'Query',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'ProfileQueriesProfileVesselsListQuery',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '91296e864a8ecd556a4f32ec4b0888e4',
      id: null,
      metadata: {},
      name: 'ProfileQueriesProfileVesselsListQuery',
      operationKind: 'query',
      text: 'query ProfileQueriesProfileVesselsListQuery(\n  $id: ID\n) {\n  vesselList(ownerId: $id) {\n    totalCount\n  }\n}\n',
    },
  };
})();

(node as any).hash = '3fd1ec5b2317524331cd25cecf5e8272';

export default node;
